const bedc = ['bedc:admin:audit-log:read'] as const;

const integration = [] as const;

export default [...bedc, ...integration] as const;
